import { Component } from 'react';
import { Card, Table, Button, Row, Col, Container } from 'react-bootstrap'
import { listIcon, expandIcon, envelopeIconBlack, mobileIcon  } from '../../img/font_awesome/font_awesome';
import AlertHistoryView from './AlertHistoryView';
import translations from "../../config/translation/home_translations.json"
import { connect } from "react-redux";

const VISIBLE_ROWS = 10; 

const mapStateToProps = state => {
    return {
     language: state.languageReducer ? state.languageReducer : 'ENGLISH'
    };
}

class AlertHistory extends Component {

    state = {
        showModal: false
    }

    handleKeyDown = (event) => {
        // 13 is Enter. 
        if (event.type === 'keydown' && event.keyCode === 13) {
            this.setState({
                showModal: true
            })
        }
    }

    handleClick = () => {
        this.setState({
            showModal: true
        })
    }

    handleClose = () => {
        this.setState({
            showModal: false
        })
    }

    render() {

        let alertRows = <div style={{ fontWeight: 'bold' }}>{translations[this.props.language].no_history}</div>
        let expandButton = <></>
        let detailsButton = <></>

        if (this.props.alertHistoryEvents && this.props.alertHistoryEvents.length > 0) {
            let alertHistoryEvents = this.props.alertHistoryEvents.length > VISIBLE_ROWS ? this.props.alertHistoryEvents.slice(0, VISIBLE_ROWS) : this.props.alertHistoryEvents;
            let moreThanTen = this.props.alertHistoryEvents.length > VISIBLE_ROWS ? true : false;

            alertRows = <Table size='sm'>
                <tbody>
                    <tr>
                    <th className="table-td-xs">{translations[this.props.language].sent}</th>
                        <th className="table-td-xs">{translations[this.props.language].alert}</th>
                       
                    </tr>
                    {
                        alertHistoryEvents.map((alertHistoryEvent, index) => {
                            return <tr key={index}>
                                <td className="table-td-xs">
                                    <span> {alertHistoryEvent.deliveryMethodType === 'EMAIL' ? envelopeIconBlack : mobileIcon}<span className="sr-only">{alertHistoryEvent.deliveryMethodType === 'EMAIL' ? 'Email sent on' : 'Text sent on' }</span></span> &nbsp;{alertHistoryEvent.deliveredTimestampFormatted}
                                </td>
                                <td className="table-td-xs">{alertHistoryEvent.alertName}</td>
                            </tr>
                        })
                    }
                    { 
                        moreThanTen &&
                        <tr key={"1" + VISIBLE_ROWS}>
                            <td className="table-td-xs"></td>
                            <td className="table-td-xs"><span className='badge badge-light'>{translations[this.props.language].more}</span></td>
                        </tr>
                    }
                </tbody>
            </Table>

            expandButton = <span onClick={this.handleClick} onKeyDown={this.handleKeyDown} tabIndex={0} style={{ cursor: "pointer", float: 'right' }}>{expandIcon} <span className="sr-only">Expand Alert History Window</span></span>
            detailsButton = <Button variant="primary" className='btn-sm' onClick={this.handleClick}>{translations[this.props.language].details}</Button>
        }
     
        return (
            <>
                <Card>
                    <Card.Header style={{ backgroundColor: '' }}> 
                        {listIcon}&nbsp;&nbsp;{translations[this.props.language].alert_history}  {expandButton}
                    </Card.Header>
                    <Card.Body>
                        <Container>
                            <Row>
                                <Col>
                                    {alertRows}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {detailsButton}
                                </Col>
                            </Row>
                        </Container>

                    </Card.Body>
                </Card>      
                <AlertHistoryView show={this.state.showModal}  handleClose={this.handleClose} />
            </>
        )
    }
}

export default connect(mapStateToProps)(AlertHistory);
